import React from 'react';

// Import styled components
import { Wrapper, LoaderWrapper, Container } from './styles';

// Import atoms
import { Loader } from 'components/elements';

// Import helpers
import { RECAPTCHA_CONTAINER_ID } from './helpers';

import useRecaptcha from './useRecaptcha';

function Recaptcha({ updateRecaptchaResult }) {
	const { isRecaptchaLoading } = useRecaptcha(updateRecaptchaResult);

	return (
		<Wrapper>
			<Container id={RECAPTCHA_CONTAINER_ID} $loading={isRecaptchaLoading} />
			{isRecaptchaLoading && (
				<LoaderWrapper>
					<Loader
						width={8}
						height={8}
						zIndex={100}
						position="absolute"
						background={false}
					/>
				</LoaderWrapper>
			)}
		</Wrapper>
	);
}

export default Recaptcha;
